// Words for the Loop page and the Overview's loop row. Keys are reclip-api's
// (`stream/metrics/loop/pushes.py`): the push kinds are its NotificationType
// names, and `about_is` says what a push was about where a listen can be of it.

export const PUSH_KINDS = {
  stream_moment: 'a new quote of theirs',
  friend_quotes: 'friends’ new quotes',
  comment: 'a comment',
  friend_request: 'a friend request',
  friend_accepted: 'a friend accepted',
}

export const ABOUT_WORDS = {
  quote: 'that quote',
  friend: 'a quote by that friend',
}

// The window's pushes summed across kinds: what the Overview's loop row
// draws. `about` sums only the kinds where a listen can be of the subject.
export const pushTotals = (kinds = []) =>
  kinds.reduce(
    (sum, row) => ({
      sent: sum.sent + row.sent,
      counted: sum.counted + row.counted,
      visited: sum.visited + row.visited,
      heard: sum.heard + row.heard,
      about: sum.about + (row.about ?? 0),
    }),
    { sent: 0, counted: 0, visited: 0, heard: 0, about: 0 }
  )

export const share = (n, of) => (of > 0 ? n / of : null)

export const fmtShare = (value) =>
  value == null ? '—' : `${Math.round(value * 100)}%`

// A quote push's outcomes as the selection pass decides them (reclip-api
// `stream/selection/push.py`), in the order they are read: what went, what
// failed, then the skips, which are policy and never a loss. The Pushes tab
// gives one it does not name yet a column of its own.
export const QUOTE_PUSH_OUTCOMES = [
  {
    key: 'pushed',
    label: 'pushed',
    help: 'Braze took the push.',
  },
  {
    key: 'push_failed',
    label: 'failed',
    help: 'Braze refused it or never answered, even after retries. The one loss.',
    tone: 'error.main',
  },
  {
    key: 'push_retrying',
    label: 'retrying',
    help: 'Braze refused the push or never answered, and its retry is queued.',
    tone: 'warning.main',
  },
  {
    key: 'skipped_not_in_port',
    label: 'not in the port',
    help: 'The owner’s phone doesn’t run the new app, so there’s nothing to push to.',
  },
  {
    key: 'skipped_audience',
    label: 'staff-only',
    help: 'Staff-only, from before pushes opened to the new app.',
  },
  {
    key: 'skipped_push_off',
    label: 'push off',
    help: 'Push is off in this environment.',
  },
  {
    key: 'skipped_withheld',
    label: 'withheld for media',
    help: 'The quote sounds like a TV or music and is withheld.',
  },
  {
    key: 'no_copy',
    label: 'nothing to say',
    help: 'No copy could be written for the push.',
  },
]

export const QUOTE_PUSH_SKIPS = QUOTE_PUSH_OUTCOMES.filter(
  ({ key }) => !key.startsWith('push')
)
